import { $$, on } from "../../utils/dom";
import { renderCloseIcon } from "../../utils/icons";

const removeFile = (
  li: HTMLLIElement,
  input: HTMLInputElement,
  fileName: string,
  uploadedFilesContainer: Element
) => {
  const attachments = input.files;
  var fileBuffer = new DataTransfer();

  if (attachments !== null) {
    for (let i = 0; i < attachments.length; i++) {
      if (fileName !== attachments[i].name)
        fileBuffer.items.add(attachments[i]);
    }

    input.files = fileBuffer.files;
      if (input.files.length === 0) {
          li.parentElement?.remove();
          uploadedFilesContainer.classList.remove("-active");
      }
      else {
          li.parentNode?.removeChild(li);
      }
  }

  if (input.files?.length === 0) {
    // Remove the files container if there are no files
    const [uploadedFilesContainer] = Array.from(
      input.parentElement?.getElementsByClassName(
        "FormFileUpload__PostedFile"
      ) as HTMLCollectionOf<Element>
    );

    if (!!uploadedFilesContainer) {
      uploadedFilesContainer.classList.remove("-active");
      uploadedFilesContainer.innerHTML = "";
      handleSubmitButton(uploadedFilesContainer);
    }
  }
  return null;
};

const showUploadedFileName = (event: Event) => {
  const target = event.target as HTMLInputElement;

  if (target.files) {
    const files: File[] = Array.from(target.files);
    const fileNames: string[] = files.map((file: File) => file.name);

    const [uploadedFilesContainer] = Array.from(
      target.parentElement?.getElementsByClassName(
        "FormFileUpload__PostedFile"
      ) as HTMLCollectionOf<Element>
    );

    if (!uploadedFilesContainer)
      return console.warn(
        "No message container found, please add a container with the class 'FormFileUpload__PostedFile'"
      );

    uploadedFilesContainer.classList.add("-active");

    let ul  = uploadedFilesContainer.querySelector('ul');
    if (!ul || ul === null) {
        ul = document.createElement('ul');
        ul.classList.add("-plain", "-inline");
        uploadedFilesContainer.appendChild(ul);
    }
    ul.innerHTML = "";
    fileNames.forEach((fileName: string) => {
      const li: HTMLLIElement = document.createElement("li");
      const span: HTMLSpanElement = document.createElement("span");
      const button: HTMLButtonElement = document.createElement("button");

      li.classList.add("a-pill", "-inverted");
      span.classList.add("selected-file", "a-pill__label");
      span.innerHTML = fileName;
      button.classList.add("a-pill__close");
      button.appendChild(renderCloseIcon(button));
      button.onclick = () => removeFile(li, target, fileName, uploadedFilesContainer);

      li.appendChild(span);
      li.appendChild(button);
      ul.appendChild(li);
    });

    handleSubmitButton(uploadedFilesContainer);
  }
};

function handleSubmitButton(uploadedFilesContainer: Element) {
  const form = uploadedFilesContainer.closest("form");
  if (!form) return;
  const submitButton = form.querySelector('button[type="submit"]');
  if (!submitButton) return;

  return uploadedFilesContainer.children.length === 0
    ? submitButton.setAttribute("disabled", "disabled")
    : submitButton.removeAttribute("disabled");
}

export const onContentLoaded = (): void => {
  const fileUploadInputs = $$('input[type="file"]');

  if (fileUploadInputs?.length) {
    Array.from(fileUploadInputs).forEach((uploadInput) => {
      on(uploadInput, "change", showUploadedFileName);
    });
  }
};

if (process.env.NODE_ENV !== "development") {
  document.addEventListener("DOMContentLoaded", onContentLoaded);
}
